import { isValid } from "date-fns";

/** Narrows values coming from date pickers, which yield an Invalid Date on incomplete or impossible input. */
export const isValidDate = (date: string | Date | undefined | null): date is string | Date =>
  !!date && isValid(new Date(date));
